import { useIntl } from 'react-intl'

import { Device } from '@/lib/types'

export const useDeviceName = ({
  device,
  customDeviceCount
}: {
  device: Device | undefined
  customDeviceCount?: number
}) => {
  const { formatMessage } = useIntl()

  const { miner, type, count } = device || {}
  const { name } = miner || {}

  const isFullMiner = type === 'full'

  const fullMinerName =
    count && count > 1
      ? `${formatMessage(
          {
            id: 'device.count',
            defaultMessage:
              '{count, plural, one {# устройство} few {# устройства} many {# устройств} other {# устройств}} {name}'
          },
          { name, count: customDeviceCount || count }
        )}`
      : name

  const deviceName = isFullMiner
    ? fullMinerName
    : `${customDeviceCount || device?.hashrate} TH ${formatMessage({
        id: 'of',
        defaultMessage: 'от'
      })} ${name}`

  return { deviceName }
}
